import styled from "styled-components";

export const BaseList = styled.div`
  ${(props) => (props.overflowY ? `overflow-y: ${props.overflowY};` : ``)}
  width: ${(props) => props.width};
  /*height:100%
flex: 1 1 auto;*/
  height: ${(props) => props.height};
  ${(props) => (props.maxHeight ? `max-height: ${props.maxHeight};` : ``)}
`;

export const BaseListItem = styled.div`
display:flex;
background-color: ${(props) => props.theme.colors.white};
align-items: center;

& > *:not(:last-child) {
  flex: 0 1 auto;
  padding-inline-end: 10px;
}

padding: ${(props) => props.padding};
${(props) =>
  props.backgroundColor ? `background-color: ${props.backgroundColor};` : ``}
${(props) =>
  props.borderColor ? `border-bottom: 1px solid ${props.borderColor};` : ``}
${(props) => (props.margin ? `margin: ${props.margin};` : ``)}
box-shadow: ${(props) => props.shadow};
${(props) => (props.cursor ? `cursor:${props.cursor};` : ``)}
${(props) => props.draggingOverBorder}
${(props) =>
  props.hoverColor
    ? `
&:hover{
  background-color: ${props.hoverColor};
  }`
    : ``}
  ${(props) =>
    props.activeColor
      ? `

&:active{
  background-color: ${props.activeColor};
  }`
      : ``}
}
`;

export const BaseListItemIcon = styled.div`
  display: flex;
  cursor: ${(props) => props.cursor};
`;

export const ListItemWrapperIcon = styled.div`
  padding-inline-end: 0px;
`;

export const BaseListItemIconButton = styled.div`
  display: flex;
`;
export const BaseListItemElement = styled.div`
  display: flex;
`;
export const BaseListItemSecondary = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;
  align-self: ${(props) => props.position};
  & > *:not(:last-child) {
    padding-inline-end: 10px;
  }
`;

export const BaseListItemHeader = styled.div`
  top: 0;
  position: sticky;
  z-index: 1;
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    padding-inline-end: 10px;
  }
  padding: ${(props) => props.padding};
  ${(props) =>
    props.backgroundColor ? `background-color: ${props.backgroundColor};` : ``}
  ${(props) =>
    props.borderBottom ? `border-bottom: 1px solid ${props.borderBottom};` : ``}
`;

export const BaseListItemFooter = styled.div`
  bottom: 0;
  position: sticky;
  display: flex;
  width: -webkit-fill-available;
  align-items: center;
  & > *:not(:last-child) {
    padding-inline-end: 10px;
  }
  padding: 12px 10px;
  ${(props) =>
    props.backgroundColor ? `background-color: ${props.backgroundColor};` : ``}
  ${(props) =>
    props.borderTop ? `border-top: 1px solid ${props.borderTop};` : ``}

  ${(props) =>
    props.hover ? `&:hover { ${props.hover} & > * { ${props.hover}}}` : ``};
`;

export const TextInputWrapper = styled.div`
  display: flex;
  padding: 0px 10px;
  width: 100%;
  height: 40px;
  align-items: center;
`;

export const Spacer = styled.div`
  padding: 0 5px;
`;
